import { SwapIcon } from "./ActionIcons";

const SwapDirectionIcon = () => (
  <div className="flex h-[30px] w-[29px] -rotate-90 items-center justify-center text-[#4ab932]">
    <SwapIcon />
  </div>
);

export default SwapDirectionIcon;
